// extracted by css-extract-rspack-plugin
export default {"root":"root-HbdHkL","slotTargetTitle":"slotTargetTitle-ibKV5o","slotTargetTitleselected":"slotTargetTitleselected-I99AfY"};